import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
      aria-label={`查看漫画：${comic.title}`}
    >
      <div className="relative overflow-hidden rounded-lg aspect-[5/7] mb-3">
        <img
          src={comic.cover}
          alt={comic.title}
          title={`虚空韩漫网 - ${comic.title}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-900/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-semibold bg-accent-500 text-background-50 rounded-md whitespace-nowrap">
            已完结
          </span>
        )}

        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <span className="inline-block px-2 py-1 text-[10px] font-medium bg-primary-500 text-background-50 rounded-md mb-1.5 whitespace-nowrap">
            {comic.chapters}话
          </span>
        </div>
      </div>

      <h3
        className={`font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 ${
          size === 'large' ? 'text-base' : 'text-sm'
        }`}
      >
        {comic.title}
      </h3>

      <p className="text-xs text-foreground-500 mt-1 line-clamp-1">{comic.author}</p>

      <div className="flex items-center gap-2 mt-1.5">
        <div className="flex items-center gap-0.5">
          <i className="ri-star-fill text-secondary-500 text-xs"></i>
          <span className="text-xs font-semibold text-foreground-700">{comic.rating}</span>
        </div>
        <span className="text-xs text-foreground-400">{comic.views >= 10000 ? `${(comic.views / 10000).toFixed(1)}万` : comic.views}次阅读</span>
      </div>
    </Link>
  );
}